//ALerts
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { toast } from "react-toastify";
export const AlertPopups = {
	confirmMsg: "Are you sure?",
	successMsg: "Success",
	cancelMsg: "Are you sure you want to cancel?",
	createTicketConfirm: "Are you sure you want to create ticket?",
	saveChangesConfirm: "Save changes?",
	saveChangesMsg: "Changes saved",
	rejectTicketConfirm: "Are you sure you want to reject the ticket?",
	rejectTicketMsg: "Ticket rejected",
	acceptTicketConfirm: "Are you sure you want to accept ticket?",
	acceptTicketMsg: "Ticket accepted",
	completeMsg: "Ticket marked complete",
	commentsErr: "Comments are required",
	confirmBox: Swal.mixin({
		//conform
		width: 300,
		showCancelButton: true,
		showCloseButton: false,
		confirmButtonText: "Yes",
		cancelButtonText: "No",
		confirmButtonColor: "#009999",
		animation: false,
	}),
	successAlert: {
		fire: (props) => {
			return toast.success(props.text);
		},
	},
	ErrorAlert: {
		fire: (props) => {
			return toast.error(props.text);
		},
	},
	WarningAlert: {
		fire: (props) => {
			return toast.warn(props.text);
		},
	},
	InfoAlert: {
		fire: (props) => {
			return toast.info(props.text);
		},
	},
};
